import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=1f96f3e0&"
import script from "./LinkIcon.vue?vue&type=script&lang=ts&"
export * from "./LinkIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports